import * as fromDatatype from "../datatype-library/index";

export interface bl_del_job_subline_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  job_hdr_guid: fromDatatype.GuidDataFieldInterface;
  job_dochdr_link_guid: fromDatatype.GuidDataFieldInterface;
  job_docline_link_guid: fromDatatype.GuidDataFieldInterface;
  region_location_link_guid: fromDatatype.GuidDataFieldInterface;
  qty_stock_availability: fromDatatype.NumericDatatypeInterface;
  qty_to_deliver: fromDatatype.NumericDatatypeInterface;
  qty_delivered: fromDatatype.NumericDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_del_job_subline_link_RowClass
  implements bl_del_job_subline_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    job_hdr_guid: fromDatatype.GuidDataFieldInterface;
    job_dochdr_link_guid: fromDatatype.GuidDataFieldInterface;
    job_docline_link_guid: fromDatatype.GuidDataFieldInterface;
    region_location_link_guid: fromDatatype.GuidDataFieldInterface;
    qty_stock_availability: fromDatatype.NumericDatatypeInterface;
    qty_to_deliver: fromDatatype.NumericDatatypeInterface;
    qty_delivered: fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    date_created: fromDatatype.TimestampTzDatatypeInterface;
    date_updated: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}
